"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegendMarker = void 0;
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const enums_1 = require("@vamstar/fox-api-common/esm/common/enums");
const utils_1 = require("./utils");
const MARKER_MARGIN = 0.5;
const useStyles = (markerColor) => makeStyles_1.default((theme) => ({
    marker: {
        marginRight: theme.spacing(3),
    },
    shape: {
        display: 'inline-block',
        backgroundColor: theme.palette[markerColor.color][markerColor.shade],
        width: '0.5rem',
        height: '0.5rem',
        borderRadius: '50%',
        marginRight: theme.spacing(MARKER_MARGIN),
    },
}));
exports.LegendMarker = (props) => {
    const { label, marker, lastMarker } = props;
    const classes = useStyles(utils_1.getLegendMarkerColor(marker))();
    if (marker === enums_1.LegendMarkerEnum.NONE) {
        return react_1.default.createElement("span", null, label);
    }
    return (react_1.default.createElement("span", { className: !lastMarker ? classes.marker : '' },
        react_1.default.createElement("span", { className: classes.shape }),
        " ",
        label));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGVnZW5kTWFya2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvbGVnZW5kcy9MZWdlbmRNYXJrZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7Ozs7OztBQUVILGtEQUEwQjtBQUUxQix3RUFBZ0Q7QUFFaEQsb0VBQTRFO0FBRzVFLG1DQUErQztBQUUvQyxNQUFNLGFBQWEsR0FBRyxHQUFHLENBQUM7QUFFMUIsTUFBTSxTQUFTLEdBQUcsQ0FBQyxXQUErQixFQUFFLEVBQUUsQ0FDcEQsb0JBQVUsQ0FBQyxDQUFDLEtBQVksRUFBRSxFQUFFLENBQUMsQ0FBQztJQUM1QixNQUFNLEVBQUU7UUFDTixXQUFXLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7S0FDOUI7SUFDRCxLQUFLLEVBQUU7UUFDTCxPQUFPLEVBQUUsY0FBYztRQUN2QixlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsS0FBSyxDQUFDLENBQUMsV0FBVyxDQUFDLEtBQUssQ0FBQztRQUNwRSxLQUFLLEVBQUUsUUFBUTtRQUNmLE1BQU0sRUFBRSxRQUFRO1FBQ2hCLFlBQVksRUFBRSxLQUFLO1FBQ25CLFdBQVcsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQztLQUMxQztDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRU8sUUFBQSxZQUFZLEdBQUcsQ0FBQyxLQUF5QixFQUFFLEVBQUU7SUFDeEQsTUFBTSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsVUFBVSxFQUFFLEdBQUcsS0FBSyxDQUFDO0lBQzVDLE1BQU0sT0FBTyxHQUFHLFNBQVMsQ0FBQyw0QkFBb0IsQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLENBQUM7SUFFMUQsSUFBSSxNQUFNLEtBQUssd0JBQWdCLENBQUMsSUFBSSxFQUFFO1FBQ3BDLE9BQU8sNENBQU8sS0FBSyxDQUFRLENBQUM7S0FDN0I7SUFFRCxPQUFPLENBQ0wsd0NBQU0sU0FBUyxFQUFFLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFO1FBQ2hELHdDQUFNLFNBQVMsRUFBRSxPQUFPLENBQUMsS0FBSyxHQUFJOztRQUFFLEtBQUssQ0FDcEMsQ0FDUixDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=